import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'account';

export const actionTypes = {
  GET_ACCOUNT_INFO: `${FEATURE_NAME}/GET_ACCOUNT_INFO`,
  GET_CONNECTED_ACCOUNT_INFO: `${FEATURE_NAME}/GET_CONNECTED_ACCOUNT_INFO`,
  UPDATE_SELECTED_SITE: `${FEATURE_NAME}/UPDATE_SELECTED_SITE`,
  UPDATE_ACCOUNT: `${FEATURE_NAME}/UPDATE_ACCOUNT`,
  UPLOAD_AVATAR: `${FEATURE_NAME}/UPLOAD_AVATAR`,
  LOGOUT: `${FEATURE_NAME}/LOGOUT`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
